<template>

    <div class="col-span-6 text-sm">


        <div class="flex flex-row justify-between items-start">

            <div class="flex flex-grow flex-col items-start justify-center flex-shrink-0 flex-1">
                <span class="font-medium mt-1">Background colour</span>
                <div class="text-sm mt-3">Set the #hex color code to match your brand</div>
            </div>

            <!-- <div class="flex justify-center items-center flex-shrink">
                <div class="border-4 bg-white border-transparent rounded-full w-16 h-16 flex flex-col justify-center cursor-pointer flex-shrink"
                    :style="'border-color:'+widget_settings.color">
                    <div
                        class="rounded-full w-12 h-12 border-2 border-dashed border-transparent flex flex-col justify-center self-center relative overflow-hidden bg-gray-100 transform duration-200 hover:scale-90"
                        :class="{'border-gray-400 hover:border-gray-700 hover:border-solid':!active_custom}"
                        :style="'background-color:'+widget_settings.color">

                        <HashtagIcon class="flex self-center z-10 w-6 h-6"
                            :class="{'text-white':!is_light,'text-black':is_light}" />

                        <input
                            class="absolute opacity-0 z-20 block cursor-pointer w-12 h-12"
                            v-tippy="{content:'Pick your color'}"
                            type="color"
                            :value="widget_settings.color"
                            @change="changeCustom($event)" />
                    </div>
                </div>
            </div> -->

            <div class="flex justify-end items-center gap-x-3">

                <div class="flex items-center rounded-lg overflow-hidden" :style="testButtonStyle">

                    <input type="text" ref="team_name_field" :value="widget_settings.color"
                        @input="changeCustom($event)"
                        class="text-left w-24 inline py-1.5 px-3 border-0 border-gray-200 focus:ring-0 focus:border-birdie-dark bg-gray-100 focus:bg-blue-50 text-birdie-grey focus:text-birdie-dark text-sm"
                        placeholder="#28AC72" maxlength="7" style="padding-bottom:0.3rem;padding-top:0.3rem" />

                    <div class="relative w-10 h-7 rounded-r-lg flex justify-center items-center">
                        <EyeDropperIcon class="w-4 h-4" :style="testButtonStyle" />
                        <input class="absolute top-0 left-0 opacity-0 z-20 block cursor-pointer w-full h-full"
                            v-tippy="{ content: 'Color picker' }" type="color" :value="widget_settings.color"
                            @change="changePicker($event)" />
                    </div>
                </div>

                <!-- <input
                    class="cursor-pointer w-12 h-12"
                    v-tippy="{content:'Pick your color'}"
                    type="color"
                    :value="widget_settings.color"
                    @change="changeCustom($event)" /> -->

                <!-- <jet-button class="hover:opacity-70 py-2" @click="openExternalRecorder()" :style="testButtonStyle">
                    Test
                    <ArrowTopRightOnSquareIcon class="w-4 h-4 ml-2" />
                </jet-button> -->

            </div>
        </div>

        <jet-section-border />

        <div class="flex flex-col justify-between items-start">
            <div class="flex flex-grow flex-col items-start justify-center flex-shrink-0 flex-1">
                <span class="font-medium mt-1">Footnote text (optional)</span>
            </div>
            <div class="w-full mt-3">
                <input type="text" :disabled="!canChangeDisclaimer" :value="disclaimer"
                    @input="changedDisclaimer($event)" placeholder="All recordings will be deleted after 90 days"
                    class="text-left w-full inline py-2 mt-0 px-3 border-0 border-gray-200 focus:ring-0 focus:border-blue-500 bg-gray-100 focus:bg-blue-50 text-birdie-blue focus:text-blue-600 rounded-lg text-sm"
                    :class="{ 'opacity-50': !canChangeDisclaimer }" />
            </div>
        </div>


        <jet-section-border />

        <div class="flex flex-row justify-center">
            <span class="flex-grow font-medium">
                Customers can enter text before sending a recording
            </span>
            <toggle :checked="customer_can_add_comment" @click.prevent.stop @update="toggleAddComment"></toggle>
        </div>

        <div
            class=" mt-5 -mx-4 -mb-5 sm:-mx-6 sm:-mb-6 flex items-center justify-end px-4 py-3 bg-gray-50 border-t border-gray-200 text-right sm:px-6 sm:rounded-bl-md sm:rounded-br-md">

            <jet-button class="hover:opacity-70 py-2" @click="openExternalRecorder()" :style="testButtonStyle">
                Test
                <ArrowTopRightOnSquareIcon class="w-4 h-4 ml-2" />
            </jet-button>

        </div>




    </div>



</template>






<script>

import ColorUtil from "@/tools.js"
import ButtonLink from '@/Jetstream/ButtonLink'
import { HashtagIcon } from "@heroicons/vue/20/solid"
import JetSectionBorder from '@/Jetstream/SectionBorder'
import Toggle from '@/Components/UI/Toggle'
import { ArrowTopRightOnSquareIcon } from "@heroicons/vue/20/solid"
import JetButton from '@/Jetstream/Button'
import { EyeDropperIcon } from "@heroicons/vue/20/solid";




export default {

    props: ['w_settings'],

    components: {
        HashtagIcon, ButtonLink, JetSectionBorder, Toggle,
        ArrowTopRightOnSquareIcon, JetButton, EyeDropperIcon
    },

    data() {
        return {

            widget_settings: this.w_settings,

            timeout: Object,
            buffer: 750,
            buffer2: 1100,

            saving: false,

            lastTypeMoment: 0,

            canChangeDisclaimer: true,

        }
    },

    created() {

    },
    computed: {
        disclaimer() {
            return this.widget_settings.footer_message ?? ''
        },
        active_custom() {
            return true
        },
        is_light() {
            return ColorUtil.lightOrDark(this.widget_settings.color) == "light"
        },
        customer_can_add_comment() {
            if (this.widget_settings.customer_can_add_comment) {
                return this.widget_settings.customer_can_add_comment == 'yes'
            }
            return false
        },
        testButtonStyle() {
            var toreturn = 'background-color:' + this.widget_settings.color + ';'
            if (this.is_light) {
                toreturn += 'color:black;'
            } else {
                toreturn += 'color:white;'
            }
            return toreturn
        }
    },
    mounted() {
    },
    methods: {
        openExternalRecorder() {
            //if (typeof window.zest !== undefined) {
            window.initRecorder(this.$page.props.user.current_team.slugname,
                this.$page.props.user.id,
                this.$page.props.app_url,
                true, false, this.$page.props.user.email)
            //}
        },
        openInternalRecorder() {
            window.initRecorder(this.$page.props.user.current_team.slugname,
                this.$page.props.user.id,
                this.$page.props.app_url,
                true)
        },

        changedDisclaimer: function (event) {
            let now = new Date().getTime();
            if (now - this.lastTypeMoment < this.buffer2) {
                clearTimeout(this.timeout);
            }
            this.lastTypeMoment = now;
            this.timeout = setTimeout(function () {
                this.updateDisclaimer(event.target.value)
            }.bind(this), this.buffer2);
        },
        updateDisclaimer: function (value) {
            if (!this.$page.props.canManageSettings) {
                return
            }
            let url = this.$page.props.api_url + '/v1/settings/appearance';
            var params = {
                footer_message: value,
            };
            axios.post(url, params)
                .then(response => {
                    //console.log(response.data);
                    if (response.data) {
                        this.widget_settings = JSON.parse(response.data.settings)
                        let options = {
                            type: "default",
                            timeout: 2500,
                            position: "top-right",
                            hideProgressBar: false,
                        }
                        this.$moshaToast("Setting updated!", options)
                    }
                })
                .catch(e => {
                    console.error(e);
                });

        },

        changePicker: function (event) {
            var newColor = event.target.value
            if (newColor.substring(0, 1) != '#') {
                newColor = '#' + newColor
            }
            //let regex = /^#([A-F0-9]{3}|[A-F0-9]{6})$/i
            let regex = /^#([A-F0-9]{6})$/i
            if (!newColor.match(regex)) {
                return
            }
            this.changeColor(newColor)
        },

        changeCustom: function (event) {

            var newColor = event.target.value
            if (newColor.substring(0, 1) != '#') {
                newColor = '#' + newColor
            }
            //let regex = /^#([A-F0-9]{3}|[A-F0-9]{6})$/i
            let regex = /^#([A-F0-9]{6})$/i
            if (!newColor.match(regex)) {
                return
            }

            let now = new Date().getTime();
            if (now - this.lastTypeMoment < this.buffer) {
                clearTimeout(this.timeout);
            }
            this.lastTypeMoment = now;

            this.timeout = setTimeout(function () {
                this.changeColor(newColor)
            }.bind(this), this.buffer);


        },
        changeColor: function (color) {
            this.update_color(color)
        },
        update_color: function (hexVal) {
            if (!this.$page.props.canManageSettings) {
                return
            }
            let url = this.$page.props.api_url + '/v1/settings/appearance';
            var params = {
                w_col: hexVal,
            };
            this.saving = true
            axios.post(url, params)
                .then(response => {
                    //console.log(response.data);
                    if (response.data) {
                        this.widget_settings = JSON.parse(response.data.settings)
                        let options = {
                            type: "default",
                            timeout: 2500,
                            position: "top-right",
                            hideProgressBar: false,
                        }
                        this.$moshaToast("Color updated!", options)
                        this.widget_settings.color = hexVal
                        console.log(this.widget_settings.color)
                        this.saving = false
                    }
                })
                .catch(e => {
                    console.error(e);
                    this.saving = false
                });
        },
        toggleAddComment() {
            if (!this.$page.props.canManageSettings) {
                return
            }
            let url = this.$page.props.api_url + '/v1/settings/appearance';
            var params = {
                customer_can_add_comment: this.customer_can_add_comment ? "no" : "yes",
            };
            axios.post(url, params)
                .then(response => {
                    //console.log(response.data);
                    if (response.data) {
                        this.widget_settings = JSON.parse(response.data.settings)
                        let options = {
                            type: "default",
                            timeout: 2500,
                            position: "top-right",
                            hideProgressBar: false,
                        }
                        this.$moshaToast("Setting updated!", options)
                    }
                })
                .catch(e => {
                    console.error(e);
                });

            if (this.customer_can_add_comment) {
                this.widget_settings.customer_can_add_comment = "no"
            } else {
                this.widget_settings.customer_can_add_comment = "yes"
            }
        },

    }

}

</script>
